import { render, staticRenderFns } from "./local-admin-users-item.vue?vue&type=template&id=13e3a81e&"
import script from "./local-admin-users-item.vue?vue&type=script&lang=js&"
export * from "./local-admin-users-item.vue?vue&type=script&lang=js&"
import style0 from "./local-admin-users-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports